import { ANIMATION_END, TRANSITION_END } from 'constants/css';

export const onAnimationEnd = (element: HTMLElement, event = 'animationend') => new Promise((resolve) => {
  const handler = () => {
    element.removeEventListener(event, handler);
    resolve();
  };

  element.addEventListener(event, handler);
});


export const restartAnimation = (element: HTMLElement) => {
  const { className } = element;
  element.className = '';
  /* eslint-disable no-unused-expressions */
  // tslint:disable-next-line
  element.offsetWidth;
  element.className = className;
};

export const onAnimation = (element: HTMLElement, handler: (event: AnimationEvent) => void): (() => void) => {
  element.addEventListener(ANIMATION_END, handler as any, false);

  return () => element.removeEventListener(ANIMATION_END, handler as any);
};

export const onAnimationName = (element: HTMLElement, handler: (animationName: string) => void): (() => void) =>
  onAnimation(element, ({ animationName }) => handler(animationName));

export const onTransition = (element: HTMLElement, handler: (event: TransitionEvent) => void): (() => void) => {
  element.addEventListener(TRANSITION_END, handler as any, false);

  return () => element.removeEventListener(TRANSITION_END, handler as any);
};
